module.exports = __webpack_public_path__ + "img/btn-to-bottom.3479471e.png";